import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';

const paymentConnectRequestHandler = {

  getConnectedAch: (fwdId: number): Promise<ApiResponse<boolean>> => {

    return genericApi.get(`payment_connect/ach/fwd/${fwdId}`);
  },
  connectAch: (publicToken: string, metadata: any): Promise<ApiResponse<boolean>> => {

    return genericApi.post('payment_connect/ach', { publicToken, metadata });
  }
};

export default paymentConnectRequestHandler;
